import { dismissNotice, emptyNoticeState, pushNotice } from '../../../shared/notice-rules';
import { NOTIFICATION_TYPE } from './constants';
export function emptyWebNoticeStack() {
    return { rules: emptyNoticeState(), seen: [] };
}
function variantOf(appearance) {
    if (appearance === NOTIFICATION_TYPE.ERROR || appearance === NOTIFICATION_TYPE.WARNING)
        return 'error';
    return appearance === NOTIFICATION_TYPE.SUCCESS ? 'success' : 'info';
}
function ids(rules) {
    return [rules.current, ...rules.queue].filter(Boolean).map(notice => notice.id);
}
/**
 * The next stack for the redux list `items` (in its order). Returns the uid
 * that shows and the uids the rules dropped.
 */
export function foldWebNotices(stack, items, now) {
    const present = new Set(items.map(item => item.uid));
    let rules = stack.rules;
    // Gone from redux (timed out, closed, cleared): the next one shows.
    for (const id of ids(rules)) {
        if (!present.has(id))
            rules = dismissNotice(rules, id, now);
    }
    const seen = new Set(stack.seen.filter(uid => present.has(uid)));
    for (const item of items) {
        if (seen.has(item.uid))
            continue;
        seen.add(item.uid);
        rules = pushNotice(rules, {
            actionLabel: item.hasAction ? 'action' : undefined,
            id: item.uid,
            text: item.uid,
            variant: variantOf(item.appearance)
        }, now);
    }
    const kept = new Set(ids(rules));
    return {
        hide: items.filter(item => !kept.has(item.uid)).map(item => item.uid),
        stack: { rules, seen: [...seen] },
        visible: rules.current ? rules.current.id : null
    };
}
